import 'core-js/stable';
import 'regenerator-runtime/runtime';
import Vue from 'vue';

import { OktaAuth } from "@okta/okta-auth-js";
import OktaVue from "@okta/okta-vue";

// Application
import App from './App.vue';
import { GlobalConfiguration } from './shared/GlobalConfiguration';

// Store
import store from '@/store/index';

// Plugins
import { router } from '@/plugins/Router';
import { i18n } from '@/plugins/I18n';
import vuetify from '@/plugins/Vuetify';

// CSS
import '@/assets/scss/_base.scss';
import VueTheMask from 'vue-the-mask';
import 'vuetify/dist/vuetify.min.css';

// Filtres
import '@/shared/filters/NumberFilter';
import '@/shared/filters/DateFilter';

import '@engie-ec/app-launcher-okta-b2b';
import { AuthHelper } from './components/auth/AuthHelper';
Vue.config.ignoredElements = ['app-launcher-okta-b2b'];

Vue.config.productionTip = false;

Vue.use(VueTheMask);

/**
 *  Méthode de configuration de l'instance root Vue et de ses Plugins
 */
async function vueSetup() {
    // Lecture des paramètres en configuration
    await GlobalConfiguration.read().then(
        async () => {

            // Authentification
            Vue.use(OktaVue, {
                oktaAuth: new OktaAuth({
                    issuer: GlobalConfiguration.oktaIssuer,
                    clientId: GlobalConfiguration.oktaClientId,
                    redirectUri: window.location.origin + "/auth/callback",
                    scopes: ["openid", "profile", "email"],
                    pkce: false,
                    restoreOriginalUri: (_oktaAuth, originalUri) =>
                        AuthHelper.restoreOriginalUriCustom(originalUri),
                }),
            });

            new Vue({
                store,
                router,
                i18n,
                vuetify,
                render: (h) => h(App),
            }).$mount('#app');
        });
}

vueSetup();
